export default __webpack_public_path__ + "static/customer-lockers-da526237e5eee8c3f0f25df8932b109d.jpg";